module.exports = __webpack_public_path__ + "img/03.0b13a459.png";